import React, { useState } from 'react';

import SimpleSelect from '../../utils/FormWidgets/SimpleSelect';
import { updatePartyMember } from '../../../services/PartiesService';
import { Member, RsvpStatus } from '../../../types/Member';

const rsvpStatusOptions = [
  { value: 'going', label: 'Going' },
  { value: 'maybe', label: 'Maybe' },
  { value: 'declined', label: 'Declined' },
];

type MemberRsvpStatusProps = {
  member: Member;
};

const MemberRsvpStatus = ({ member }: MemberRsvpStatusProps) => {
  const [rsvpStatus, setRsvpStatus] = useState(member.rsvpStatus);

  const onRsvpStatusChange = (value: RsvpStatus) => {
    updatePartyMember({ ...member, rsvpStatus: value });
    setRsvpStatus(value);
  };

  return (
    <div onClick={e => e.stopPropagation()}>
      <SimpleSelect
        // @ts-ignore
        onChange={(value: RsvpStatus) => onRsvpStatusChange(value)}
        value={rsvpStatus}
        data={rsvpStatusOptions}
      />
    </div>
  );
};

export default MemberRsvpStatus;
